import { Children, isValidElement, ReactNode } from 'react';

// Native selects stringify option values. Keep the original numeric/string value
// expected by existing Formik and MUI Select callbacks and API DTOs.
export const selectEvent = (event: any, children: ReactNode) => {
    const originalValues = new Map<string, unknown>();
    const visit = (nodes: ReactNode) => Children.forEach(nodes, node => {
        if (!isValidElement(node)) return;
        const props = node.props as any;
        if ('value' in props) originalValues.set(String(props.value), props.value);
        else if (props.children) visit(props.children);
    });
    visit(children);
    const value = event.target.multiple
        ? Array.from(event.target.selectedOptions as HTMLOptionElement[]).map(option => originalValues.get(option.value) ?? option.value)
        : originalValues.get(event.target.value) ?? event.target.value;
    const target = new Proxy(event.target, {get(element, key) {if (key === 'value') return value;const result = Reflect.get(element,key,element);return typeof result === 'function' ? result.bind(element) : result;}});
    return Object.assign(Object.create(event), {target,currentTarget:target});
};
